import React from 'react';
import { IoChevronBackSharp, IoChevronForwardSharp } from "react-icons/io5"

const FormFooter = (props) => {
    const handleGoPrev = (event) => {
        //change page
props.previousPage(event);

    }
    const handleGoForw = (event) => {
        //change page
        props.nextPage(event);
    }

    return (
        <>
            <div className='AppFormBar noShadow'>
                <div className='pagination w-100 d-flex justify-content-center'>
                    <div className='pageNum d-flex align-items-center'>
                        <button type="button" className='btn d-flex align-items-center gap-2' onClick={handleGoPrev} disabled={props.currentPage === 1}>
                            <IoChevronBackSharp /> Previous
                        </button>

                        <button type="button" className='btn d-flex align-items-center gap-2' onClick={handleGoForw} disabled={props.currentPage === props.totalPages}>
                            Next <IoChevronForwardSharp />
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}

export default FormFooter;